<template>
  <section id="view-contact">
    <div class="box">
      <p class="title">联系我们，让档案管理更高效</p>
      <p class="sub_title">提交信息即可免费体验，商务顾问将与您沟通定制解决方案</p>
      <el-button type="primary" round class="trial-button" @click="openTrialDialog">
        马上预约体验
      </el-button>
    </div>
  </section>
</template>

<script>
export default {
  name: 'TryoutProject',
  inject: ['openTrialDialog']
}
</script>

<style scoped>
#view-contact {
  width: 100%;
  height: 336px;
  padding-top: 80px;
  background-color: #0f9dfc;
  font-family: "Montserrat Light", "PingFang SC", "Hiragino Sans GB", "Microsoft Jhenghei", "Avenir", "Helvetica Neue", Arial, sans-serif;
}
.title {
  color: #fff;
  font-size: 32px;
  line-height: 1.1;
}
.sub_title {
  margin-top: 16px;
  color: #fff;
  font-size: 16px;
  line-height: 1.1;
}
.box {
  width: 100%;
  text-align: center;
}
.trial-button {
  margin-top: 10px;
  border-color: #1f5dea;
  background-color: #1f5dea;
}
@media (max-width: 768px) {
  #view-contact { height: auto; padding: 60px 20px; }
  .title { font-size: 26px; }
  .sub_title { font-size: 14px; line-height: 1.6; }
}
</style>
